import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children }) => (
  <div className="min-h-screen bg-white text-slate-900 antialiased font-body">
    <Navbar />
    <main>{children}</main>
    <Footer />
  </div>
);

export default Layout;
